import { ReactNode } from 'react';

import { useDroppable } from '@dnd-kit/core';
import { Box, Typography, useTheme } from '@mui/material';

import { DroppableCFSContainer } from './styles';

interface DroppableCFSProps {
  cfsId: string;
  cfsNumber: string;
  address: string;
  children: ReactNode;
  disabled?: boolean;
}

export const DroppableCFS = ({
  cfsId,
  cfsNumber,
  address,
  children,
  disabled = false,
}: DroppableCFSProps) => {
  const { isOver, setNodeRef } = useDroppable({
    id: cfsId,
    data: { type: 'cfs', cfsId, cfsNumber, address },
    disabled,
  });

  const theme = useTheme();

  return (
    <DroppableCFSContainer
      ref={setNodeRef}
      className={isOver ? 'cfs-hover' : ''}
      data-cfs-id={cfsId}
      data-is-droppable="true"
      theme={theme}
    >
      {children}
      {isOver && (
        <Box className="cfs-tooltip">
          <Typography variant="body2">{cfsNumber}</Typography>
          <Typography variant="body1">{address}</Typography>
        </Box>
      )}
    </DroppableCFSContainer>
  );
};
